export const SET_TRU_VALIDATE_BLACKBOX = 'SET_TRU_VALIDATE_BLACKBOX'
const initialState = {
  loggedIn: false,
  FIRST_NAME: '',
  MIDDLE_NAME: '',
  LAST_NAME: '',
  ORG_NAME: '',
  USERNAME: '',
  PHONE: '',
  BUSINESS_NAME: '',
  WEB_USER_ID: 0,
  USER_GROUP: 'PUBLIC',
  isFrequentPayor: false,
  checkingAuthState: false,
  expires: null,
  initialAuthCheck: true,
  rights: [],
  roles: [],
  appUserRights: [],
  truValidateRequest: { BlackBox: {}, userId: null },
  loginRedirecting: false,
}

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_AUTH_ATTRIBUTE':
      return { ...state, [action.attribute]: action.value }
    case 'SPREAD_AUTH_ATTRIBUTES':
      return { ...state, ...action.payload }
    case 'CLEAR_USER':
      return { ...state, ...initialState, initialAuthCheck: false, loginRedirecting: state.loginRedirecting }
    case 'TOGGLE_LOGGED_IN':
      return { ...state, loggedIn: action.loggedIn }
    case 'SET_EXPIRATION':
      return { ...state, expires: action.expires }
    case 'SET_APP_USER_RIGHTS':
      return { ...state, appUserRights: (action.appUserRights || []).map((x) => x.AppRightName) }
    case 'SET_APP_USER_ID':
      return { ...state, appUserID: action.appUserID }
    case SET_TRU_VALIDATE_BLACKBOX:
      return {
        ...state,
        truValidateRequest: { userId: state.appUserID, BlackBox: action.blackbox },
      }
    case 'SET_LOGIN_REDIRECTING':
      return { ...state, loginRedirecting: action.loginRedirecting }
    default:
      return state
  }
}

export default AuthReducer
